import type { Technique } from '../types';
import { FLUID_PARAMS } from './params';
import { draw, elementCount, init, isComplete, step, type FluidState } from './render';

export const fluid: Technique<FluidState> = {
  id: 'fluid',
  name: 'Fluid-Simulation',
  category: 'physics',
  description: 'Stable-Fluids-Löser mit dem Text als Hindernis; Farbstoff strömt um die Buchstaben.',
  params: FLUID_PARAMS,
  renderer: 'canvas2d',
  isAnimated: false,
  init,
  step,
  isComplete,
  draw,
  elementCount,
};
